export default "__VITE_ASSET__DN40Evki__"